import { useEffect, useState } from "react";
import {
  PartFieldsFragment,
  useCurrentParticipantQuery,
} from "../../generated/platform";

export const useCurrentUser = (showError: (raw?: any) => void) => {
  const { data, loading, error } = useCurrentParticipantQuery({
    variables: {
      expoCode: process.env.REACT_APP_EXPO_CODE || "",
    },
  });
  const [user, setUser] = useState<PartFieldsFragment | undefined>();

  useEffect(() => {
    if (!loading && data?.participant && data?.participant[0]) {
      setUser(data.participant[0]);
    }
    if (!loading && error) {
      showError(error);
    }
  }, [loading, data, error, showError]);

  return { user, loading };
};
